import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBoutByRefCode } from "../firebase/services";
import logo from "../assets/logo.png";

// QR landing page for elimination-bout referees. Redeeming the code creates the
// scoped access session before the ref is sent to the code-free bout URL.
export default function RefJoin() {
  const location = useLocation();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = new URLSearchParams(location.search).get("code");
    if (!code) {
      setError("This referee link is missing its bout code.");
      return;
    }

    getBoutByRefCode(code.trim().toUpperCase())
      .then((bout) => {
        if (!bout) throw new Error("Bout not found. Ask the tournament administrator for a new QR code.");
        if (bout.status === "confirmed") throw new Error("This bout has already been confirmed.");
        navigate(`/ref/${bout.eventId}/${bout.id}`, { replace: true });
      })
      .catch((err) => {
        console.error(err);
        setError(err.message || "Unable to open this bout.");
      });
  }, [location.search, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center">
      <img src={logo} alt="" className="w-full max-w-xs mx-auto mb-6" />
      {error ? (
        <>
          <div role="alert" className="text-red-400 text-sm bg-red-900 bg-opacity-20 rounded-lg p-3 mb-5">{error}</div>
          <Link to="/" className="text-gray-500 text-sm no-underline hover:text-gray-300">Back to home</Link>
        </>
      ) : (
        <div className="text-gray-500 text-sm">Opening referee view...</div>
      )}
    </div>
  );
}
